import Button from 'components/Button';
import Modal from 'components/Modal';
import Text from 'components/Text';
import { SortableList } from 'features/settingService/components/SortableList';
import settingApis from 'features/settingService/services/apis';
import { useState } from 'react';
import { getMessageError, IResponseDataBody } from 'services/response';
import shopActions from 'services/shop/actions';
import { IProductItemData } from 'services/shop/types/product';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import toast from 'utils/toast';
type Props = {
  data: IProductItemData[];
};
const ArrangeProductsModal = ({ data = [] }: Props) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<{ id: string; name: string; price: number }[]>([]);
  const dispatch = useAppDispatch();

  const handleOpen = () => {
    setItems(data.map((o) => ({ id: o.id, name: o.productName, price: o.priceSell })));
    setOpen(true);
  };

  const handlePreOrder = async () => {
    setOpen(false);

    try {
      const res: IResponseDataBody = await settingApis.sortsProducts(items.map((o) => o.id));

      if (res?.data?.data) {
        toast.success('Arrange products successfully');
        dispatch(shopActions.get.productCategories.fetch());
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Arrange products failed');
    }
  };

  return (
    <>
      <Button icon='sortService' ntype='DARK_BLUE' onClick={handleOpen} disabled={data.length === 0}>
        Pre-Order
      </Button>
      <Modal
        v2
        visible={open}
        onClose={() => setOpen(false)}
        onSubmit={handlePreOrder}
        modalTitle='Pre-Order'
        noneBodyStyle
      >
        <Container>
          <SortableList
            items={items}
            onChange={setItems}
            renderItem={(item) => (
              <SortableList.Item id={item.id}>
                <CateWrap>
                  <Text variant='H7' color='text_3'>
                    {item.name}
                  </Text>
                  <Text variant='CONTENT_1' color='text_2'>
                    {formatCurrency(item.price)}
                  </Text>
                </CateWrap>
              </SortableList.Item>
            )}
          />
        </Container>
      </Modal>
    </>
  );
};

export default ArrangeProductsModal;

const CateWrap = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  .label {
    font-size: 18px;
    font-weight: 600;
  }
`;

const Container = styled.div`
  padding: 16px;
  background-color: #fff;
`;
